import React, { useMemo, useState } from "react";

export default function AdminList({
    toolbar,
    columns,
    items,
    loading,
    emptyText = "Нет данных",
    totalText,
    getRowKey = (x, i) => x?._id || i,
    renderSubrow,
    cols,
    colsMd,
    colsSm,
    theme = "dark",
    expandedId: controlledExpandedId,
    onToggleExpand
}) {
    const [uncontrolledExpandedId, setUncontrolledExpandedId] = useState(null);
    const expandedId = controlledExpandedId ?? uncontrolledExpandedId;
    const toggle = (key) => {
        if (onToggleExpand) onToggleExpand(key);
        else setUncontrolledExpandedId((p) => (p === key ? null : key));
    };

    const gridVars = useMemo(() => {
        const v = {};
        if (cols) v["--al-cols"] = cols;
        if (colsMd) v["--al-cols-md"] = colsMd;
        if (colsSm) v["--al-cols-sm"] = colsSm;
        return v;
    }, [cols, colsMd, colsSm]);

    return (
        <div className={`admin-list admin-list--${theme}`}>
            <div className="admin-list__toolbar">
                {toolbar?.search ? (
                    <div className="admin-list__search">
                        {toolbar.search.icon ? toolbar.search.icon : (
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M21 21l-4.3-4.3m1.8-5.2a7 7 0 11-14 0 7 7 0 0114 0z" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" />
                            </svg>
                        )}
                        <input
                            value={toolbar.search.value || ""}
                            onChange={(e) => toolbar.search.onChange && toolbar.search.onChange(e.target.value)}
                            placeholder={toolbar.search.placeholder || ""}
                        />
                    </div>
                ) : null}

                {Array.isArray(toolbar?.filters) && toolbar.filters.map((f, i) => (
                    <select key={i} className="admin-list__select" value={f.value} onChange={(e) => f.onChange && f.onChange(e.target.value)}>
                        {(f.options || []).map((o) => <option key={String(o.value)} value={o.value}>{o.label}</option>)}
                    </select>
                ))}

                {Array.isArray(toolbar?.actions) && toolbar.actions.map((b, i) => (
                    <button key={i} className={`admin-list__btn ${b.variant ? `admin-list__btn--${b.variant}` : ""}`} onClick={() => b.onClick && b.onClick()}>
                        {b.label}
                    </button>
                ))}
            </div>

            <div className="admin-list__table">
                <div className="admin-list__head" style={gridVars}>
                    {columns.map((c) => (
                        <div key={c.key} className={c.headerClassName || `col col--${c.key}`}>{c.title}</div>
                    ))}
                    {columns.some(c => c.key === "__actions") ? <div className="admin-list__actions admin-list__actions--head" /> : null}
                </div>

                {loading ? (
                    <div className="admin-list__loader">
                        <div className="spinner" />
                        <span>Загрузка…</span>
                    </div>
                ) : !items?.length ? (
                    <div className="admin-list__empty">{emptyText}</div>
                ) : (
                    items.map((item, index) => {
                        const key = getRowKey(item, index);
                        const isExpanded = expandedId === key;
                        const ctx = { isExpanded, toggle: () => toggle(key) };
                        return (
                            <React.Fragment key={key}>
                                <div className="admin-list__row" style={gridVars}>
                                    {columns.map((c) => {
                                        if (c.key === "__actions") {
                                            return (
                                                <div key={`${key}-__actions`} className="admin-list__actions">
                                                    {c.cell ? c.cell(item, index, ctx) : null}
                                                </div>
                                            );
                                        }
                                        return (
                                            <div key={`${key}-${c.key}`} className={c.className || `col col--${c.key}`}>
                                                {c.cell ? c.cell(item, index, ctx) : item[c.key]}
                                            </div>
                                        );
                                    })}
                                </div>
                                {isExpanded && renderSubrow ? <div className="admin-list__subrow">{renderSubrow(item, index, ctx)}</div> : null}
                            </React.Fragment>
                        );
                    })
                )}
            </div>

            {totalText ? <div className="admin-list__total">{totalText}</div> : null}
        </div>
    );
}
